import React from 'react';
import { mui } from '@local/finsera-core/src/libs';

export const FinDataGridFilterDialog = React.memo(function FinDataGridFilterDialog() {
  const apiRef = mui.dataGrid.useGridApiContext();

  const handleClose = React.useCallback(() => {
    apiRef.current.hidePreferences();
  }, [apiRef]);

  return (
    <mui.core.Dialog
      open
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      keepMounted
      hideBackdrop
      disableScrollLock
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
        },
      }}
    >
      <mui.core.DialogTitle sx={{ pb: 1.5, px: 3, pt: 3 }}>Filters</mui.core.DialogTitle>

      <mui.core.DialogContent
        sx={{
          px: 3,
          pb: 3,
          pt: 2.5,
          '.MuiDataGrid-filterForm': {
            alignItems: 'center',
            columnGap: 2,
            rowGap: 1.5,
            borderRadius: 4,
            mb: 3,
            mt: 2,
          },
        }}
      >
        <mui.dataGrid.GridFilterPanel />
      </mui.core.DialogContent>
    </mui.core.Dialog>
  );
});
